import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  FormHelperText,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Modal,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { decode } from "base-64";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'sonner';
import * as Yup from "yup";
import { api } from "../api";
import AuthContext from "../auth/AuthProvider";
import { fetchToken } from "../auth/Token";
import Address from "../components/Address";
import AssociationDetails from "../components/AssociationDetails";
import AssociationDisbursedLoans from "../components/AssociationDisbursedLoans";
import AssociationMembers from "../components/AssociationMembers";
import AssociationShareInfo from "../components/AssociationShareInfo";
import Header from "../components/Header";
import MoreDetails from "../components/MoreDetails";
import PersonalDetails from "../components/PersonalDetails";
import TransactionSummary from "../components/TransactionSummary";
import { useMode } from "../theme";
import MassDeposit from "./MassDeposit";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

const steps = ["Personal Details", "Address", "More Details"];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const OneAssociation = () => {
  const [value, setValue] = useState();
  const [value1, setValue1] = useState("1");
  const location = useLocation();
  const [theme, colorMode] = useMode();
  const [nyoma, setNyoma] = useState([]);
  const [isSidebar, setIsSidebar] = useState(true);
  const responseData = location.state && location.state.responseData;
  const [open, setOpen] = React.useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const id = responseData.Association_id;
  const [bie, setBie] = useState(false);
  const navigate = useNavigate();
  const [allMembers, setAllMembers] = useState([]);
  const [members, setMembers] = useState({});
  const [leaders, setLeaders] = useState([]);
  const { permissions } = useContext(AuthContext);
  const [exist, setExist] = useState({
    member_id: null,
    association_id: id,
  });
  const [all_accounts, setAll_accounts] = useState([]);
  const [modal_o, setModal_o] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  // console.log(nyoma)

  const emptyIt = () => {
    api
      .delete(`/transactions/mass/withdrawal/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if(response.data == "You are not allowed to perform this operation"){
          toast.error(response.data)
        }else{
          toast.success(response.data);
        }
        setModalOpen(false)
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleLeadershipDelete = (leader_id) => {
    api
      .delete(`/association/delete/association/leader/${leader_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        fetchLeaders();
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const formatDateToRelative = (date) => {
    const diff = Math.floor(
      (new Date() - new Date(date)) / (1000 * 60 * 60 * 24)
    );
    if (diff < 1) {
      return "today";
    } else if (diff < 30) {
      return `Established ${diff} ${diff === 1 ? "day" : "days"} ago`;
    } else if (diff < 365) {
      const months = Math.floor(diff / 30);
      return `Established ${months} ${months === 1 ? "month" : "months"} ago`;
    } else {
      const years = Math.floor(diff / 365);
      return `Established ${years} ${years === 1 ? "year" : "years"} ago`;
    }
  };

  const renderTitle = (date) => {
    const formattedDate = formatDateToRelative(date);
    return (
      <Chip
        variant="outlined"
        size="small"
        sx={{
          m: "5px",
          boxShadow:
            "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
        }}
        color="success"
        label={formattedDate}
      />
    );
  };

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const fetchLeaders = () => {
    const cacheKey = `leaders_${id}`;
    const cachedLeaders = localStorage.getItem(cacheKey);
  
    if (cachedLeaders) {
      const parsedLeaders = JSON.parse(cachedLeaders);
      setLeaders(parsedLeaders);
    } else {
      api
        .get(`/association/get/association/leaders/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const leadersData = response.data;
          setLeaders(leadersData);
          localStorage.setItem(cacheKey, JSON.stringify(leadersData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 920,
    maxHeight: "90vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const fetch_all_accounts = () => {
    const cacheKey = "all_accounts";
    const cachedAccounts = localStorage.getItem(cacheKey);
  
    if (cachedAccounts) {
      const parsedAccounts = JSON.parse(cachedAccounts);
      setAll_accounts(parsedAccounts);
    } else {
      api
        .get("/account/all/accounts", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const accountsData = response.data;
          setAll_accounts(accountsData);
          localStorage.setItem(cacheKey, JSON.stringify(accountsData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    fetch_all_accounts();
    fetchLeaders();
  }, []);

  const fetchMembersLeaders = () => {
    const cacheKey = `membersLeaders_${id}`;
    const cachedMembers = localStorage.getItem(cacheKey);
  
    if (cachedMembers) {
      const parsedMembers = JSON.parse(cachedMembers);
      setMembers(parsedMembers);
    } else {
      api
        .get(`/members/allmembers/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const membersData = response.data;
          setMembers(membersData);
          localStorage.setItem(cacheKey, JSON.stringify(membersData)); // Cache the fetched data
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  
  useEffect(() => {
    fetchMembersLeaders();
  }, [id]);

  const formik_leader = useFormik({
    initialValues: {
      leaders: [],
    },
    onSubmit: (values) => {
      const data = {
        association_id: id,
        leaders: values.leaders,
      };
      api
        .post("/association/set/association/leaders", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          formik_leader.handleReset();
          fetchLeaders();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  });

  const handleClickBie = () => {
    setLoading(false);
    setBie(true);
  };

  const handleTum = () => {
    setBie(false);
  };

  const [accounts, setAccounts] = useState([]);
  const [savingsTotal, setSavingsTotal] = useState(0);
  const [sharesTotal, setSharesTotal] = useState(0);
  const [loansTotal, setLoansTotal] = useState(0);
  const [commodityTotal, setCommodityTotal] = useState(0);
  const [associationWorth, setAssociationWorth] = useState(0);

  const fetchAccounts = () => {
    const cacheKey = `accounts_${id}`;
    const cachedAccounts = localStorage.getItem(cacheKey);
  
    if (cachedAccounts) {
      const parsedAccounts = JSON.parse(cachedAccounts);
      setAccounts(parsedAccounts);
    } else {
      api
        .get(`/association/passbook/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const accountsData = response.data;
          setAccounts(accountsData);
          localStorage.setItem(cacheKey, JSON.stringify(accountsData)); // Cache the fetched data
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    fetchAccounts();
  }, [id]);

  // Total Savings Account Balance
  useEffect(() => {
    if (accounts.All_Savings_account) {
      let totalSaveValue = 0;
      accounts.All_Savings_account.forEach((saveItem) => {
        totalSaveValue += saveItem.current_balance;
      });
      setSavingsTotal(totalSaveValue);
    }
  }, [accounts.All_Savings_account]);

  //   console.log(savingsTotal);

  //   Total Shares Account Balance
  useEffect(() => {
    if (accounts.All_Shares_acount) {
      let totalshareValue = 0;
      accounts.All_Shares_acount.forEach((shareItem) => {
        totalshareValue += shareItem.current_balance;
      });
      setSharesTotal(totalshareValue);
    }
  }, [accounts.All_Shares_acount]);

  //   console.log(sharesTotal);

  //   Total Loans Account Balance
  useEffect(() => {
    if (accounts.All_Loans_account) {
      let totalloanValue = 0;
      accounts.All_Loans_account.forEach((loanItem) => {
        totalloanValue += loanItem.current_balance;
      });
      setLoansTotal(totalloanValue);
    }
  }, [accounts.All_Loans_account]);

  //   console.log(loansTotal);

  //   Total Commodity Account Balance
  useEffect(() => {
    if (accounts.All_Commodity_account) {
      let totalcommodityValue = 0;
      accounts.All_Commodity_account.forEach((commodityItem) => {
        totalcommodityValue += commodityItem.cash_value;
      });
      setCommodityTotal(totalcommodityValue);
    }
  }, [accounts.All_Commodity_account]);

  // console.log(commodityTotal);
  useEffect(() => {
    setAssociationWorth(
      savingsTotal + sharesTotal + commodityTotal + loansTotal
    );
  }, [savingsTotal, loansTotal, sharesTotal, commodityTotal]);

  const fetchAllMembers = () => {
    const cacheKey = `allMembers_${id}`;
    const cachedMembers = localStorage.getItem(cacheKey);
  
    if (cachedMembers) {
      const parsedMembers = JSON.parse(cachedMembers);
      setAllMembers(parsedMembers);
    } else {
      api
        .get(`/members/everymember/${id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const membersData = response.data;
          setAllMembers(membersData);
          localStorage.setItem(cacheKey, JSON.stringify(membersData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    fetchAllMembers();
  }, []);

  const registerExistingMember = (event) => {
    event.preventDefault();
    setLoading(true);
    api
      .post("/members/recieve/details", exist, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        handleTum();
        setExist({
          member_id: null,
          association_id: id,
        });
        fetchAllMembers();
        
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      firstname: "",
      middlename: "",
      lastname: "",
      otherName: "",
      commonname: "",
      dob: "2023-01-02",
      gender: "",
      ghCardNumber: "",
      memberImage: null,
      phone: "",
      otherPhone: "",
      address: "",
      otherAddress: "",
      nextOfKin: "",
      ghCardImage: null,
      MaritalStatus: "",
      EducationLevel: "",
      Town: "",
      ruralOrUrban: "",
    },
    validationSchema: Yup.object({
      firstname: Yup.string().required("First name is required"),
      dob: Yup.date().required("Date of Birth is required"),
      gender: Yup.string().required("Must Specify Gender"),
      ghCardNumber: Yup.string(),
    }),
    onSubmit: (values) => {
      if (activeStep === steps.length - 1) {
        setLoading(true);
        const data = new FormData();
        data.append("association_id", id);
        data.append("firstname", values.firstname);
        data.append(
          "middlename",
          values.middlename === null ? "" : values.middlename
        );
        data.append(
          "lastname",
          values.lastname === null ? "" : values.lastname
        );
        data.append(
          "otherName",
          values.otherName === null ? "" : values.otherName
        );
        data.append(
          "commonname",
          values.commonname === null ? "" : values.commonname
        );
        data.append("dob", values.dob === null ? "" : values.dob);
        data.append("gender", values.gender === null ? "" : values.gender);
        data.append(
          "ghCardNumber",
          values.ghCardNumber === null ? null : values.ghCardNumber
        );
        data.append("memberImage", values.memberImage);
        data.append("phone", values.phone === null ? "" : values.phone);
        data.append(
          "otherPhone",
          values.otherPhone === null ? "" : values.otherPhone
        );
        data.append("address", values.address === null ? "" : values.address);
        data.append(
          "otherAddress",
          values.otherAddress === null ? "" : values.otherAddress
        );
        data.append(
          "nextOfKin",
          values.nextOfKin === null ? "" : values.nextOfKin
        );
        data.append("ghCardImage", values.ghCardImage);
        data.append(
          "MaritalStatus",
          values.MaritalStatus === null ? "" : values.MaritalStatus
        );
        data.append(
          "EducationLevel",
          values.EducationLevel === null ? "" : values.EducationLevel
        );
        data.append("Town", values.Town === null ? "" : values.Town);
        data.append(
          "ruralOrUrban",
          values.ruralOrUrban === null ? "" : values.ruralOrUrban
        );
        api
          .post("/members/register", data, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
              "Content-Type": "multipart/form-data",
            },
          })
          .then(function (response) {
            if (response.data === "Card Number already exists") {
              toast.error(response.data);
            } else { 
              toast.success(response.data);
              formik.handleReset();
              handleClose();
              fetchAllMembers();
              
            }
          })
          .catch(function (error) {
            console.log(error)
            toast.error(error.response.data.detail);
          })
          .finally(function () {
            setLoading(false);
          });
      } else {
        setActiveStep((prevStep) => prevStep + 1);
      }
    },
  });

  const formContent = (step) => {
    switch (step) {
      case 0:
        return <PersonalDetails formik={formik} />;
      case 1:
        return <Address formik={formik} />;
      case 2:
        return <MoreDetails formik={formik} />;
      default:
        return <div>404: Not Found</div>;
    }
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const details = () => {
    const cacheKey = `associationDetails_${responseData.Association_id}`;
    const cachedDetails = localStorage.getItem(cacheKey);
  
    if (cachedDetails) {
      const parsedDetails = JSON.parse(cachedDetails);
      setNyoma(parsedDetails);
    } else {
      api
        .get(`association/specified/${responseData.Association_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const associationDetails = response.data;
          setNyoma(associationDetails);
          localStorage.setItem(cacheKey, JSON.stringify(associationDetails));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  useEffect(() => {
    details();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
    },
    {
      field: "Name",
      headerName: "Member",
      flex: 1,
    },
    {
      field: "passbookId",
      headerName: "Passbook ID",
      flex: 1,
    },
    // {
    //   field: 'actions',
    //   type: 'actions',
    //   getActions: (params: GridRowParams) => [
    //   <GridActionsCellItem
    // icon={<LaunchOutlinedIcon />}
    // onClick={() => handleClick(params.row.association_id)}
    //   label="Open Passbook"
    //   />]
    // }
  ];

  const handleMemberRegister = () => {
    handleClickOpen();
  };

  function handleAssociationPassbook() {
    navigate("/passbook/association/", {
      state: {
        id: responseData.Association_id,
        association_name: `${responseData.Association_name} ${responseData.Association_Type}`,
      },
    });
  }

  const handleEcash = () => {
    const somm = {
      association_id: responseData.Association_id,
      typee: "savings",
      date: new Date(),
    };
    api
      .post("/association/cash/settings", somm, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (reponse) {
        navigate("/accounts/momo", {
          state: {
            association_id: responseData.Association_id,
            association_name: `${responseData.Association_name} ${responseData.Association_Type}`,
          },
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const [loading, setLoading] = useState(false);

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  if (responseData) {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            {/* HEADER */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header
                title={responseData.Association_name}
                subtitle={responseData.Association_Type}
              />
            </Box>

            <Divider variant="middle" />
            <Grid container spacing={2}>
              <Grid item md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: 4,
                  }}
                >
                  <CardContent>
                    <IconButton>
                      <GroupsOutlinedIcon />
                    </IconButton>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      gutterBottom
                      variant="h5"
                      component="div"
                    >
                      <b>Total Members: {members.length}</b>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: 4,
                  }}
                >
                  <CardContent>
                    <IconButton>
                      <AccountBalanceWalletOutlinedIcon />
                    </IconButton>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      gutterBottom
                      variant="h5"
                      component="div"
                    >
                      <b>
                        Net Worth: {currencyFormat.format(associationWorth)}
                      </b>
                    </Typography>
                    <Chip
                        size="small"
                        label={
                          <Typography
                            variant="subtitle"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Clear Data</b>
                          </Typography>
                        }
                        sx={{
                          borderRadius: 2,
                          m: 1,
                          boxShadow:
                            "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                          backgroundColor: "#da1e37",
                          color: "#fff",
                          "&:hover": {
                            boxShadow:
                              "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "#14213d",
                          },
                        }}
                        onClick={() => setModalOpen(true)}
                      />
                  </CardContent>
                </Card>
              </Grid>

              <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
                <DialogTitle>
                  <WarningRoundedIcon style={{ marginRight: '8px' }} />
                  Confirmation
                </DialogTitle>
                <Divider />
                <DialogContent>
                  Are you sure you want empty all accounts in Group?<br/>
                  This action is not reversible!
                </DialogContent>
                <DialogActions>
                  <Button variant="contained" color="error" onClick={() => emptyIt(false)}>
                    Withdraw
                  </Button>
                  <Button variant="text" color="inherit" onClick={() => setModalOpen(false)}>
                    Cancel
                  </Button>
                </DialogActions>
              </Dialog>
              <Grid item md={4}>
                <Card
                  sx={{
                    minWidth: 280,
                    margin: 4,
                    display: "flex",
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: 4,
                  }}
                >
                  <CardContent>
                    <IconButton>
                      <LocationCityIcon />
                    </IconButton>
                    <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      gutterBottom
                      variant="h5"
                      component="div"
                    >
                      <b>Kind: {responseData.Association_Type}</b>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Box sx={{ justifyContent: "space-between", display: "flex" }}>
              {permissions && permissions.create_member === true ? (
                <ButtonGroup
                  // orientation="vertical"
                  variant="contained"
                  color="success"
                  sx={{
                    marginLeft: "25px",
                    borderRadius: 4,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#2b2d42",
                  }}
                  aria-label="vertical outlined button group"
                >
                  <Button
                    sx={{
                      borderRadius: 4,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#2b2d42",
                    }}
                    onClick={handleMemberRegister}
                  >
                    Register Member
                  </Button>
                  <Button
                    sx={{
                      borderRadius: 4,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#2b2d42",
                    }}
                    onClick={handleClickBie}
                  >
                    Register Existing Member
                  </Button>
                </ButtonGroup>
              ) : (
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    marginLeft: "25px",
                    borderRadius: 4,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#2b2d42",
                  }}
                  onClick={handleClickBie}
                >
                  Register Existing Member
                </Button>
              )}
              <div>
                <Button
                  variant="contained"
                  sx={{
                    marginLeft: "25px",
                    borderRadius: 4,
                    boxShadow:
                      "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#2b2d42",
                  }}
                  onClick={() => setModal_o(true)}
                >
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Leaders</b>
                  </Typography>
                </Button>
              </div>

              <div>
                {permissions &&
                permissions.view_association_passbook === true ? (
                  <Button
                    variant="contained"
                    color="success"
                    sx={{
                      marginRight: "5px",
                      borderRadius: 4,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#2b2d42",
                    }}
                    onClick={handleAssociationPassbook}
                  >
                    Open Passbook
                  </Button>
                ) : null}
                {permissions &&
                permissions.view_association_momo_account === true ? (
                  <Button
                    variant="contained"
                    color="success"
                    sx={{
                      marginRight: "25px",
                      borderRadius: 4,
                      boxShadow:
                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "#2b2d42",
                    }}
                    onClick={handleEcash}
                  >
                    E-Cash Account
                  </Button>
                ) : null}
              </div>
            </Box>

            <Divider variant="middle" sx={{ marginTop: "10px" }} />
            <Box mr="10px" ml="10px" paddingBottom="35px">
              {permissions && permissions.view_association === true ? (
                <>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    {permissions &&
                    permissions.disburse_approved_loans === true ? (
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        centered
                      >
                        <Tab
                          label={`${responseData.Association_name} Details`}
                          {...a11yProps(0)}
                        />

                        <Tab label="Loans" {...a11yProps(1)} />
                        <Tab label="Shares" {...a11yProps(2)} />

                        <Tab label="Members" {...a11yProps(3)} />

                        <Tab
                          disabled={
                            permissions &&
                            permissions.create_savings_transactions !== true
                          }
                          label="Mass Actions"
                          {...a11yProps(4)}
                        />
                        <Tab label="Transaction Summary" {...a11yProps(5)} />
                      </Tabs>
                    ) : (
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        centered
                      >
                        <Tab
                          label={`${responseData.Association_name} Details`}
                          {...a11yProps(0)}
                        />

                        <Tab label="Shares" {...a11yProps(1)} />

                        <Tab label="Members" {...a11yProps(2)} />

                        <Tab
                          disabled={
                            permissions &&
                            permissions.create_savings_transactions !== true
                          }
                          label="Mass Actions"
                          {...a11yProps(3)}
                        />
                        <Tab label="Transaction Summary" {...a11yProps(4)} />
                      </Tabs>
                    )}
                  </Box>
                  {permissions &&
                  permissions.disburse_approved_loans === true ? (
                    <>
                      <CustomTabPanel value={value} index={0}>
                        <AssociationDetails
                          details={details}
                          name={nyoma.Association_name}
                          type={responseData.Association_Type}
                          id={responseData.Association_id}
                          nyoma={nyoma}
                        />
                      </CustomTabPanel>

                      <CustomTabPanel value={value} index={1}>
                        <AssociationDisbursedLoans
                          savingsTotal={savingsTotal}
                          association_data={responseData}
                          sharesTotal={sharesTotal}
                          loansTotal={loansTotal}
                          commodityTotal={commodityTotal}
                          associationWorth={associationWorth}
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>

                      <CustomTabPanel value={value} index={2}>
                        <AssociationShareInfo
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={3}>
                        <AssociationMembers
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>

                      {permissions &&
                      permissions.create_savings_transactions === true ? (
                        <>
                          <CustomTabPanel value={value} index={4}>
                            <MassDeposit association_data={responseData} id={responseData.Association_id} />
                          </CustomTabPanel>
                          <CustomTabPanel value={value} index={5}>
                            <TransactionSummary
                              name={nyoma.Association_name}
                              all_accounts={all_accounts}
                              id={responseData.Association_id}
                            />
                          </CustomTabPanel>
                        </>
                      ) : (
                        <CustomTabPanel value={value} index={4}>
                          <TransactionSummary
                            all_accounts={all_accounts}
                            id={responseData.Association_id}
                          />
                        </CustomTabPanel>
                      )}
                    </>
                  ) : (
                    <>
                      <CustomTabPanel value={value} index={0}>
                        <AssociationDetails
                          details={details}
                          name={nyoma.Association_name}
                          type={responseData.Association_Type}
                          id={responseData.Association_id}
                          nyoma={nyoma}
                        />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={1}>
                        <AssociationShareInfo
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={2}>
                        <AssociationMembers
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      {permissions &&
                      permissions.create_savings_transactions === true ? (
                        <>
                          <CustomTabPanel value={value} index={3}>
                            <MassDeposit association_data={responseData} id={responseData.Association_id} />
                          </CustomTabPanel>
                          <CustomTabPanel value={value} index={4}>
                            <TransactionSummary
                              name={nyoma.Association_name}
                              all_accounts={all_accounts}
                              id={responseData.Association_id}
                            />
                          </CustomTabPanel>
                        </>
                      ) : (
                        <CustomTabPanel value={value} index={3}>
                          <TransactionSummary
                            all_accounts={all_accounts}
                            id={responseData.Association_id}
                          />
                        </CustomTabPanel>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    {permissions &&
                    permissions.disburse_approved_loans === true ? (
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        centered
                      >
                        <Tab label="Loans" {...a11yProps(0)} />
                        <Tab label="Shares" {...a11yProps(1)} />

                        <Tab label="Members" {...a11yProps(2)} />

                        <Tab
                          disabled={
                            permissions &&
                            permissions.create_savings_transactions !== true
                          }
                          label="Mass Actions"
                          {...a11yProps(3)}
                        />
                        <Tab label="Transaction Summary" {...a11yProps(4)} />
                      </Tabs>
                    ) : (
                      <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        centered
                      >
                        <Tab label="Shares" {...a11yProps(0)} />

                        <Tab label="Members" {...a11yProps(1)} />

                        <Tab
                          disabled={
                            permissions &&
                            permissions.create_savings_transactions !== true
                          }
                          label="Mass Actions"
                          {...a11yProps(2)}
                        />
                        <Tab label="Transaction Summary" {...a11yProps(3)} />
                      </Tabs>
                    )}
                  </Box>
                  {permissions &&
                  permissions.disburse_approved_loans === true ? (
                    <>
                      <CustomTabPanel value={value} index={0}>
                        <AssociationDisbursedLoans
                          savingsTotal={savingsTotal}
                          association_data={responseData}
                          sharesTotal={sharesTotal}
                          loansTotal={loansTotal}
                          commodityTotal={commodityTotal}
                          associationWorth={associationWorth}
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>

                      <CustomTabPanel value={value} index={1}>
                        <AssociationShareInfo
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={2}>
                        <AssociationMembers
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      {permissions &&
                      permissions.create_savings_transactions === true ? (
                        <>
                          <CustomTabPanel value={value} index={3}>
                            <MassDeposit association_data={responseData} id={responseData.Association_id} />
                          </CustomTabPanel>
                          <CustomTabPanel value={value} index={4}>
                            <TransactionSummary
                              name={nyoma.Association_name}
                              all_accounts={all_accounts}
                              id={responseData.Association_id}
                            />
                          </CustomTabPanel>
                        </>
                      ) : (
                        <CustomTabPanel value={value} index={3}>
                          <TransactionSummary
                            all_accounts={all_accounts}
                            id={responseData.Association_id}
                          />
                        </CustomTabPanel>
                      )}
                    </>
                  ) : (
                    <>
                      <CustomTabPanel value={value} index={0}>
                        <AssociationShareInfo
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      <CustomTabPanel value={value} index={1}>
                        <AssociationMembers
                          id={responseData.Association_id}
                        />
                      </CustomTabPanel>
                      {permissions &&
                      permissions.create_savings_transactions === true ? (
                        <>
                          <CustomTabPanel value={value} index={2}>
                            <MassDeposit association_data={responseData} id={responseData.Association_id} />
                          </CustomTabPanel>
                          <CustomTabPanel value={value} index={3}>
                            <TransactionSummary
                              name={nyoma.Association_name}
                              all_accounts={all_accounts}
                              id={responseData.Association_id}
                            />
                          </CustomTabPanel>
                        </>
                      ) : (
                        <CustomTabPanel value={value} index={2}>
                          <TransactionSummary
                            all_accounts={all_accounts}
                            id={responseData.Association_id}
                          />
                        </CustomTabPanel>
                      )}
                    </>
                  )}
                </>
              )}
            </Box>

            <Dialog open={open} onClose={handleClose}>
              <DialogTitle>Register New Member</DialogTitle>

              <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                  <Box sx={{ maxWidth: "600px", padding: 2 }}>
                    <Stepper activeStep={activeStep} orientation="horizontal">
                      {steps.map((label, index) => (
                        <Step key={index}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Grid container>
                      <Grid item xs={12} sx={{ padding: "20px" }}>
                        {formContent(activeStep)}
                      </Grid>
                      {formik.errors.submit && (
                        <Grid item xs={12}>
                          <FormHelperText error>
                            {formik.errors.submit}
                          </FormHelperText>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button disabled={activeStep === 0} onClick={handleBack}>
                    Back
                  </Button>

                  <Button type="submit">
                    {loading === true ? (
                      <CircularProgress />
                    ) : activeStep === steps.length - 1 ? (
                      "Finish"
                    ) : (
                      "Next"
                    )}
                  </Button>
                </DialogActions>
              </form>
            </Dialog>

            <Dialog open={bie} onClose={handleTum} fullWidth maxWidth="md">
              <DialogTitle>Register Existing Member</DialogTitle>
              <form onSubmit={registerExistingMember}>
                <DialogContent>
                  <p>Individual Members</p>

                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={allMembers.Individual_members}
                    getOptionLabel={(option) =>
                      `${option.Firstname} ${option.Lastname} (${option.GhCardNumber})`
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.Member_id === value.Member_id
                    }
                    onChange={(event, value) =>
                      setExist({
                        ...exist,
                        member_id: value.Member_id,
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Member"
                        size="small"
                      />
                    )}
                  />
                  <p>Members in other Savings Group</p>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={allMembers.Association_members}
                    getOptionLabel={(option) =>
                      `${option.firstname} ${option.lastname} (${option.association_name}) `
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.member_id === value.member_id
                    }
                    onChange={(event, value) =>
                      setExist({
                        ...exist,
                        member_id: value.member_id,
                      })
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Member"
                        size="small"
                      />
                    )}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleTum}>Cancel</Button>
                  <Button
                    variant="contained"
                    color="success"
                    disabled={loading ? true : false}
                    type="submit"
                  >
                    Register
                  </Button>
                </DialogActions>
              </form>
            </Dialog>

            {/* Leader */}
            <Modal
              open={modal_o}
              onClose={() => setModal_o(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <TabContext value={value1}>
                      <TabList
                        onChange={handleChange1}
                        sx={{
                          m: "auto",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          backgroundColor: "#ffffff",
                          borderWidth: 2,
                          borderRadius: 4,
                          p: 0,
                          maxWidth: "50%",
                          alignItems: "center",
                        }}
                        aria-label="lab API tabs example"
                      >
                        <Tab
                          sx={{
                            pt: 0,
                            pb: 0,
                            pr: 1,
                            pl: 1,
                            backgroundColor: "#ffffff",
                            borderRadius: 4,
                            borderWidth: "2px",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            m: "8px",
                          }}
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Leaders</b>
                            </Typography>
                          }
                          value="1"
                        />
                        <Tab
                          sx={{
                            pt: 0,
                            pb: 0,
                            pr: 1,
                            pl: 1,
                            backgroundColor: "#ffffff",
                            borderRadius: 4,
                            borderWidth: "2px",
                            boxShadow:
                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                            m: "8px",
                          }}
                          label={
                            <Typography
                              variant="subtitle"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>New Leaders</b>
                            </Typography>
                          }
                          value="2"
                        />
                      </TabList>
                      <TabPanel value="1">
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Typography
                              variant="h5"
                              sx={{ textAlign: "center" }}
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Leaders</b>
                            </Typography>
                          </Grid>

                          <Grid item xs={12} md={12}>
                            <List
                              sx={{
                                maxHeight: "170vh",
                                overflow: "auto",
                                "&::-webkit-scrollbar": {
                                  width: "4px",
                                  height: "4px",
                                },
                                "&::-webkit-scrollbar-track": {
                                  background: "#f1f1f1",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  background: "#888",
                                  borderRadius: "10px",
                                },
                                "&::-webkit-scrollbar-thumb:hover": {
                                  background: "#555",
                                },
                              }}
                            >
                              {leaders[0] ? (
                                leaders?.map((leader) => (
                                  <>
                                    <ListItem
                                      alignItems="flex-start"
                                      secondaryAction={
                                        <Chip
                                          color="error"
                                          variant="outlined"
                                          label="Delete"
                                          sx={{
                                            boxShadow:
                                              "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                            minWidth: 0,
                                          }}
                                          size="small"
                                          onClick={() =>
                                            handleLeadershipDelete(
                                              leader.leader_id
                                            )
                                          }
                                        />
                                      }
                                      sx={{ m: 1 }}
                                    >
                                      <ListItemAvatar>
                                        <Avatar
                                          sx={{ width: 55, height: 55, mr: 1 }}
                                          alt={leader?.name}
                                          src={pic(leader?.image)}
                                        />
                                      </ListItemAvatar>
                                      <ListItemText
                                        primary={leader?.name}
                                        secondary={
                                          <Box sx={{ display: "block" }}>
                                            <div>
                                              <Typography
                                                sx={{ display: "inline" }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>
                                                  Position: {leader?.position}
                                                </b>
                                              </Typography>
                                            </div>
                                            <div>
                                              <Typography
                                                sx={{ display: "inline" }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>
                                                  Passbook: {leader?.passbook}
                                                </b>
                                              </Typography>
                                            </div>
                                            <div>
                                              <Typography
                                                sx={{ display: "inline" }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                              >
                                                <b>Date established: </b>
                                                {renderTitle(
                                                  new Date(leader?.date)
                                                )}
                                              </Typography>
                                            </div>
                                          </Box>
                                        }
                                      ></ListItemText>
                                    </ListItem>
                                    <Divider variant="middle" />
                                  </>
                                ))
                              ) : (
                                <Box sx={{ margin: "auto" }}>
                                  <Typography
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    variant="h5"
                                    textAlign="center"
                                  >
                                    <b>No leadership established</b>
                                  </Typography>
                                </Box>
                              )}
                            </List>
                          </Grid>
                        </Grid>
                      </TabPanel>
                      {/* CREATE LEADERS */}
                      <TabPanel value="2">
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={12}>
                            <Typography
                              sx={{ textAlign: "center" }}
                              variant="h5"
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Set Group Leaders</b>
                            </Typography>
                          </Grid>
                          <Grid item xs={12} md={12}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                              <b>Select leader and position</b>
                            </Typography>
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={members}
                              multiple
                              sx={{ width: 250, m: 2 }}
                              getOptionLabel={(option) => option.Fullname}
                              isOptionEqualToValue={(option, value) =>
                                option.Member_id === value.Member_id
                              }
                              onChange={(event, value) => {
                                if (value) {
                                  const selectedIds = value.map((option) => {
                                    const position = `position_${option.Member_id}`;
                                    return {
                                      id: option.Member_id,
                                      member_name: option.Fullname,
                                      [position]: "",
                                    };
                                  });
                                  formik_leader.setFieldValue(
                                    "leaders",
                                    selectedIds
                                  );
                                } else {
                                  formik_leader.setFieldValue("leaders", []);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  fullWidth
                                  variant="standard"
                                  size="small"
                                  placeholder="Leader"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={12}>
                            {formik_leader.values.leaders.map((item) => (
                              <TextField
                                key={item.id}
                                size="small"
                                sx={{ m: 1 }}
                                fullWidth
                                value={item.position || null}
                                name={`position_${item.id}`}
                                label={`${item.member_name}'s position`}
                                onChange={(event) => {
                                  const updatedLeader =
                                    formik_leader.values.leaders.map((lead) => {
                                      if (lead.id === item.id) {
                                        const position = `position_${item.id}`;
                                        return {
                                          ...lead,
                                          [position]: event.target.value,
                                        };
                                      }
                                      return lead;
                                    });
                                  formik_leader.setFieldValue(
                                    "leaders",
                                    updatedLeader
                                  );
                                }}
                              />
                            ))}
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <Button
                              size="small"
                              variant="contained"
                              sx={{
                                m: 1,
                                backgroundColor: "#33415c",
                                borderRadius: 4,
                                boxShadow:
                                  "0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)",
                                minWidth: 0,
                                "&:hover": {
                                  boxShadow:
                                    "0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                  backgroundColor: "#80ed99",
                                  color: "#000",
                                },
                              }}
                              onClick={formik_leader.handleSubmit}
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      </TabPanel>
                    </TabContext>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          </Box>
        </main>
      </div>
    );
  } else {
    return <div>No data available</div>;
  }
};

export default OneAssociation;
